import React, { FC } from "react";

import { brand } from "../theme/brands";

interface Props {
  /** "dark" = logo sits on a dark background as-is; "light" = wrap in a dark chip when the artwork needs it */
  surface?: "dark" | "light";
  /** classes for the wrapper element */
  className?: string;
  /** classes for the img itself (size it here) */
  imgClassName?: string;
  onClick?: () => void;
}

const BrandLogo: FC<Props> = ({ surface = "dark", className = "", imgClassName = "h-9 w-auto", onClick }) => {
  const needsChip = surface === "light" && brand.logoNeedsDarkBackdrop;

  return (
    <div
      className={`inline-flex items-center ${needsChip ? "bg-neutral-900 rounded-lg px-3 py-2 " : ""}${className}`}
      onClick={onClick}
    >
      <img src={brand.logo} alt={brand.name} className={imgClassName} />
    </div>
  );
};

export default BrandLogo;
